import { Stack, StackProps } from '@chakra-ui/react';
import { Address, Contact } from '@pelicargo/types';
import { isoCountryFallback, isoStateFallback, join } from '@pelicargo/utils';
import { useMemo } from 'react';

import { LabeledValue } from './LabeledValue';

type Props = StackProps & {
  truckingRef?: string;
  readyDate: string;
  dockHours: string;
  address: Address;
  pickupContact: Partial<Contact>;
  truckCompany?: string;
  estimatedPickup?: string;
};

export const PickupSection = ({
  truckingRef,
  readyDate,
  dockHours,
  address,
  pickupContact,
  truckCompany,
  estimatedPickup,
  ...rest
}: Props) => {
  const addressText = useMemo(() => {
    return [
      address?.recipient,
      address?.line_one,
      address?.line_two,
      join([address?.city, isoStateFallback(address?.state), address?.zip_code, isoCountryFallback(address?.country)]),
    ].join('\n');
  }, [address]);

  const contactInfo = [pickupContact?.full_name, pickupContact?.phone_number, pickupContact?.email]
    .filter(Boolean)
    .join('\n');

  const minColumnWidth = '130px';

  return (
    <Stack direction="row" spacing="6" {...rest}>
      <Stack flex="1">
        <LabeledValue label="Ready Date" value={readyDate} defaultValue="-" minColumnWidth={minColumnWidth} />
        <LabeledValue
          label="Trucking Ref (PRO#)"
          value={truckingRef}
          defaultValue="-"
          minColumnWidth={minColumnWidth}
        />
        <LabeledValue label="Dock Hours" value={dockHours} defaultValue="-" minColumnWidth={minColumnWidth} />
        <LabeledValue label="Address" value={addressText} defaultValue="-" minColumnWidth={minColumnWidth} />
        <LabeledValue label="Contact" value={contactInfo} defaultValue="-" minColumnWidth={minColumnWidth} />
      </Stack>
      <Stack flex="1">
        <LabeledValue label="Truck Company" value={truckCompany} defaultValue="-" />
        <LabeledValue label="Estimated Pickup" value={estimatedPickup} defaultValue="-" />
      </Stack>
    </Stack>
  );
};
